import React from 'react';
import './life-bar.css';

function LifeBar({health, mana}) {
    return (
        <div className={'lifebar'}>
            <div style={{width: `${(health / 100) * 244}px`}} className={'bar-red'}></div>
            <div style={{width: `${(mana / 100) * 244}px`}} className={'bar-blue'}></div>
            <img src={process.env.PUBLIC_URL + '/img/barra-de-vida.png'}
                 style={{width: 400}}
                 alt="vida"/>

        </div>
    );
}

export default LifeBar;